import React from "react";
import HOC from "../../../components/HOC";
import DetailAllocation from "../../../components/screen/centralWarehouse/allocation/DetailAllocation";
import PageTemplate from "../../../components/common/particles.jsx/PageTemplate";

const DetailTransferPage = () => {
  return (
    <div className="">
      <PageTemplate
        header="Transfer Details"
        mainComponent={<DetailAllocation type={2} />}
        pageRole={35}
      />
    </div>
  );
};

export default HOC(DetailTransferPage);
